type Measurement = {
  event: 'page_view' | 'library_start' | 'lesson_progress' | 'assessment_cta' | 'workspace_cta';
  path: string;
  lesson?: string;
  direction?: 'open' | 'previous' | 'next' | 'complete';
  placement?: 'header' | 'home' | 'footer' | 'library' | 'lesson' | 'guidance';
  journey?: 'workspace' | 'policy' | 'register' | 'tools' | 'assessment';
};

export function measure(input: Omit<Measurement, 'path'> & { path?: string }) {
  const payload: Measurement = { ...input, path: input.path ?? window.location.pathname };
  const body = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/measurement', new Blob([body], { type: 'application/json' }));
      return;
    }
    void fetch('/api/measurement', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Measurement is optional and must never interrupt the visitor's task.
  }
}
